import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-500f91fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { class: "m-b-15" }
const _hoisted_3 = {
  for: "Gruppo_Sanguigno:",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_4 = ["value", "selected"]
const _hoisted_5 = { class: "m-b-15" }
const _hoisted_6 = {
  for: "Donazione_organi:",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_7 = ["value", "selected"]

import { getBloodType, getDonorStatus } from "../../../../EshJSLib/services/EshLOV";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { ref, onMounted, reactive } from "vue";
import * as model from '@/../../EshJSLib/models/patient';
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'pazienteMedicheEdit',
  emits: ['cancel'],
  setup(__props, { emit }) {

const store = patientStore();
const { patient } = storeToRefs(store);

let alertStatus = ref('');
const loading = ref(false);

const isShowModal = reactive({
  alert: false,
});




const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const showLoading = ref(false);

async function updateValue() {
  localStorage.setItem('patient', JSON.stringify(patient.value));
  patient.value.status = "update";

  const userInput = await alertModal.value?.openModal("Salvare le modifiche ? ", true);
  if (userInput) {
    showLoading.value = true;
    store.saveSchedaPaziente()
      .then(() => {
        showLoading.value = false;
        alertModal.value?.openModal("Salvato con successo! ", false)
          .then(() => emit('cancel'));
        store.refreshScheda(store.patient.id_paziente)
      })
      .catch((res) => {
        showLoading.value = false;
        alertModal.value?.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
        store.refreshScheda(store.patient.id_paziente)
      });
  }
}

const bloodGroupList = ref([] as model.bloodGroup[]);
const donorApprovalList = ref([] as model.organDonor[]);
const bloodGroupvisible = ref(false);

onMounted(() => {
  patient.value.status = "update"
  bloodGroupList.value = getBloodType();
  donorApprovalList.value = getDonorStatus();

})

function display(approval) {
  if (approval == '0') {
    return 'Non accosento';
  } else if (approval == '1') {
    return 'Accosento';
  } else {
    return approval;
  }
}




return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Modal), {
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel')))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Aggiorna') + ' ' + _ctx.$t('informazioni mediche')), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Gruppo sanguigno')), 1),
          _withDirectives(_createElementVNode("select", {
            id: "sangue",
            name: "Gruppo_Sanguineo:",
            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(patient).paziente_gruppo) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bloodGroupList.value, (bloodGroup, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: bloodGroup.value,
                key: index,
                selected: _unref(patient).paziente_gruppo != null && bloodGroup.value === _unref(patient).paziente_gruppo
              }, _toDisplayString(bloodGroup.label), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(patient).paziente_gruppo]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Donazione Organi')), 1),
          _withDirectives(_createElementVNode("select", {
            id: "organi",
            name: "Donazione_organi:",
            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(patient).paziente_donatore_organi) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(donorApprovalList.value, (approval, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: approval.value,
                key: index,
                selected: _unref(patient).paziente_donatore_organi != null && approval.value === _unref(patient).paziente_donatore_organi
              }, _toDisplayString(approval.label), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(patient).paziente_donatore_organi]
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          id: "submitMediche",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (updateValue())),
          class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        }, _toDisplayString(_ctx.$t('Salva')), 1)
      ]),
      _: 1
    }),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})